module.exports = __webpack_public_path__ + "static/img/pie-chart-2.420f490f.svg";